import { Visibility, VisibilityOff } from '@mui/icons-material'
import { InputAdornment } from '@mui/material'
import { forwardRef, ForwardRefRenderFunction, MouseEvent, useState } from 'react'
import { Input, DSInputType, InputProps } from '../Input'
import { IconButtonStyled } from './styles'
export interface PasswordProps extends InputProps {
  placeholder: string
  maxLength?: number
  errorOutline?: boolean
}

const PasswordComponent: ForwardRefRenderFunction<HTMLInputElement, PasswordProps> = (
  {
    name,
    value,
    label,
    placeholder,
    height = 41,
    maxLength = 100,
    onChange,
    error = null,
    errorOutline = false
  },
  ref
) => {
  const [show, setShow] = useState(false)

  const handleClickShowPassword = () => {
    setShow((prevState) => !prevState)
  }

  const handleMouseDownPassword = (event: MouseEvent<HTMLButtonElement>) => {
    event.preventDefault()
  }

  return (
    <Input
      ref={ref}
      design={DSInputType.MASTER_INPUT}
      name={name}
      value={value}
      label={label}
      type={show ? 'text' : 'password'}
      height={height}
      onChange={onChange}
      addorment
      InputProps={{
        endAdornment: (
          <InputAdornment position="end">
            <IconButtonStyled
              data-testid="icon-password"
              aria-label="toggle password visibility"
              onClick={handleClickShowPassword}
              onMouseDown={handleMouseDownPassword}
              edge="end"
            >
              {show ? (
                <Visibility data-testid="visibility-on" color="primary" />
              ) : (
                <VisibilityOff data-testid="visibility-off" color="primary" />
              )}
            </IconButtonStyled>
          </InputAdornment>
        ),
        placeholder,
        inputProps: {
          maxLength
        }
      }}
      error={error}
      errorOutline={errorOutline}
    />
  )
}

export const Password = forwardRef(PasswordComponent)
